import { render, staticRenderFns } from "./BrigadeCardCheckboxWithForever.vue?vue&type=template&id=85ac64e8&scoped=true&"
import script from "./BrigadeCardCheckboxWithForever.vue?vue&type=script&lang=js&"
export * from "./BrigadeCardCheckboxWithForever.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeCardCheckboxWithForever.vue?vue&type=style&index=0&id=85ac64e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ac64e8",
  null
  
)

export default component.exports
import {QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip}, component.options.components || {})
